import '@concord/ui/styles.css';
import { type LinkProps, LinkProvider, ToastProvider } from '@concord/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Link, RouterProvider } from 'react-router';
import { IS_STAGING } from './lib/build';
import { router } from './routes/router';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: true, retry: 1 } },
});

function RouterLink({ to, children, ...rest }: LinkProps) {
  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
}

// Staging: room for the banner at the top of every page (--env-bar in the UI styles).
if (IS_STAGING) document.documentElement.classList.add('env-staging');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <LinkProvider value={RouterLink}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </LinkProvider>
    </QueryClientProvider>
  </StrictMode>,
);
